import React from "react";
import LoginChoiceComponent from "../../components/LoginChoice";

const LoginChoice = () => {
  return <LoginChoiceComponent />;
};

export default LoginChoice;